
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 1L1.268 4.993a.4.4 0 00-.066.725L3.96 7.266M13 1l-2.61 9.06a.392.392 0 01-.576.231l-2.8-1.663M13 1L7.015 8.628M13 1L3.96 7.266m0 0l.978 3.06a.375.375 0 00.653.117l1.424-1.815","stroke":"#585858","stroke-width":"1.1","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    